import React, { Component } from 'react';
import { Dropdown, Header, Segment } from 'semantic-ui-react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { IUser } from '@relab/alstom-ptw-shared';
import { push } from 'connected-react-router';

import { appState } from '../redux/selectors';
import { signOutAction } from '../redux/actions';
import { RootState } from '../redux/types';

import { TranslationComponent } from './TranslationComponent';
import { LangEditModal } from './LangEditModal';
import { useTranslation } from 'react-i18next';

const HeaderLogo = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
  float: left;
  color: #282c34;
`;

interface HeaderComponentProps extends Partial<Component> {
  user: IUser;
  signOutAction: typeof signOutAction;
  push: typeof push;
}

const PHeaderComponent = ({ user, signOutAction, push }: HeaderComponentProps) => {
  const { t } = useTranslation();

  const handleSignOut = () => {
    signOutAction();
    push('/signin');
  };

  return (
    <Segment clearing>
      <HeaderLogo>
        <TranslationComponent
          stringKey={'Permit To Work - {{REACT_APP_VERSION}}'}
          values={{ REACT_APP_VERSION: window._env_.REACT_APP_VERSION }}
        />
      </HeaderLogo>

      <Header as="h2" floated="right">
        <Dropdown direction="right" text={user.email}>
          <Dropdown.Menu>
            <Dropdown.Item text={t('Logout')} onClick={handleSignOut} />
            <LangEditModal user={user} language={user.preferredLanguage ?? 'en'} />
          </Dropdown.Menu>
        </Dropdown>
      </Header>
    </Segment>
  );
};

const mapStateToProps = (state: RootState) => ({
  user: appState(state).user,
});

export const HeaderComponent = connect(mapStateToProps, { signOutAction, push })(PHeaderComponent);
